import { atom } from "jotai";

export const windowHeight = atom<number>(window.innerHeight);
